import { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Card } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

// Shared layout for the municipality Create/Edit views: a back-to-list button
// (explicit Settings path, since this resource isn't mounted at /municipalities)
// above the form Card.
export const MunicipalityFormCard = ({ children }: { children: ReactNode }) => (
    <Box mt={2}>
        <Button
            component={RouterLink}
            to="/settings/municipalities"
            startIcon={<ChevronLeftIcon />}
            size="small"
            sx={{ mb: 1 }}
        >
            Municipalities
        </Button>
        <Card>{children}</Card>
    </Box>
);
